<template>
    <div>
        <Form ref="applicationForm" :model="application" :rules="applicationRules" inline :label-width="125">
            <div>
                <FormItem label="申请人（经销商）" prop="cusName">
                    <AutoComplete v-model="application.cusName" @on-search="queryCus" placeholder="请选择申请人（经销商）"
                                  clearable>
                        <Option v-for="item in cusList" :value="item.cusName" :key="item.cusCode">{{ item.cusName }}
                        </Option>
                    </AutoComplete>
                </FormItem>
                <FormItem label="申请日期">
                    <DatePicker type="daterange" split-panels v-model="date" placeholder="请选择申请日期"></DatePicker>
                </FormItem>
            </div>
            <div>
                <FormItem label="审核状态" prop="spStatus">
                    <Select v-model="application.spStatus" placeholder="请选择审核状态">
                        <Option v-for="item in spList" :value="item.code" :key="item.code">{{item.name}}</Option>
                    </Select>
                </FormItem>
            </div>
            <FormItem class="btn-groups">
                <Button type="primary" @click="handleSubmit">查询</Button>
                <!--<Button type="default" @click="handleReset('applicationForm')">重置</Button>-->
                <Button type="default" @click="goToPage('salesEsApplication')">新增</Button>
            </FormItem>
        </Form>
        <CTable :columns="columns" :data="queryData" :total="total" :current="application.page" @change="change"
                :showPage="true"/>
    </div>
</template>

<script>
    import CTable from '@/components/CTable'
    import BtnEvent from '@/components/BtnEvent'
    import {timeFormat, amountFormat} from '@/plugin/tool'
    import {auditStatusList, auditList} from '@/plugin/enum'

    export default {
        name: 'SalesAppliList',
        mixins: [BtnEvent],
        components: {
            CTable
        },
        data() {
            return {
                date: [],
                cusList: [],
                application: {
                    page: 1,
                    pageSize: 10,
                    spType: '1'
                },
                applicationRules: {},
                spList: auditList,
                total: 0,
                queryData: [], // 表格数据
                columns: [{
                    title: '编号',
                    key: 'docCode',
                    width:120,
                    render: (h, params) => {
                        return h('div', [
                            h('a', {
                                on: {
                                    click: () => {
                                        this.goToPage('salesEsAppliInfo', {id: params.row.id})
                                    },
                                }
                            }, params.row.docCode)
                        ])
                    }
                }, {
                    title: '经销商',
                    key: 'cusName',
                    width:240,
                }, {
                    title: '含税金额',
                    key: 'applyAmount',
                    width:120,
                    render: (h, params) => {
                        return h('span', amountFormat(params.row.applyAmount))
                    }
                }, {
                    title: '折让金额',
                    key: 'tjzrAmount',
                    width:120,
                    render: (h, params) => {
                        return h('span', amountFormat(params.row.tjzrAmount))
                    }
                }, {
                    title: '申请日期',
                    key: 'createTime',
                    width:240,
                    render: (h, params) => {
                        return h('span', timeFormat(params.row.createTime, 'time'))
                    }
                }, {
                    title: '审核状态',
                    key: 'spStatus',
                    width:120,
                    render: (h, params) => {
                        return h('span', auditStatusList[params.row.spStatus])
                    }
                }, {
                    title: '操作',
                    width:120,
                    key: 'action',
                    render: (h, params) => {
                        return h('div', [
                            (params.row.spStatus === '0' || params.row.spStatus === '3') && h('a', {
                                on: {
                                    click: () => {
                                        this.goToPage('salesEsApplication', {id: params.row.id})
                                    }
                                }
                            }, '修改'),
                            (params.row.anStatus === '1' || params.row.anStatus === '2') && h('a', {
                                on: {
                                    click: () => {
                                        this.goToPage('salesEsApplication', {id: params.row.id})
                                    }
                                }
                            }, '审批')
                        ])
                    }

                }],
            }
        },
        created() {
            this.queryTableData()
        },
        methods: {
            queryCus(value) {
                this.$fetch('SysCus/getCodeName', {
                    cusName: value
                }).then(res => {
                    this.cusList = res.data.list
                })
            },
            handleSubmit() { // 查询表单校验
                this.$refs.applicationForm.validate((valid) => {
                    if (valid) {
                        this.application.page = 1
                        this.application.startDate = timeFormat(this.date[0], 'date')
                        this.application.closeDate = timeFormat(this.date[1], 'date')
                        this.queryTableData()
                    }
                })
            },
            queryTableData() { // 查询表格
                _.forEach(this.cusList, value => {
                    if (value.cusName === this.application.cusName) {
                        this.application.cusCode = value.cusCode
                    }
                })
                this.$fetch('SalesPromo/getList', this.application).then(res => {
                    this.queryData = res.data.list
                    this.total = res.data.total
                })
            },
            change(index) {
                this.application.page = index
                this.queryTableData()
            }
        }
    }
</script>
